/**
 * Посадочные места в помещении
 */
import { BaseModel } from '@n3/ng-api-base-kit';

export class RoomSeat extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public id: number; /*Идентификатор в БД*/
    public row_number: number; /*Номер ряда*/
    public seats: number; /*Количество мест в ряду*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.id = json.id || null;
        this.row_number = json.row_number || null;
        this.seats = json.seats || null;
        this._isEmpty = this.isEmpty(this);
    }
}
